import React from 'react';
import PageWithHeader from "../common/PageWithHeader";
import {Box, Button, IconButton, Typography} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import {useAppSelector} from "../../redux/hooks";
import FeedbackSurveyResponses from "./FeedbackSurveyResponses";
import {useRouter} from "../../hooks/useRouter";


const FeedbackSurveyReview: React.FC = () => {
  const router = useRouter();
  const currentUser = useAppSelector(state => state.auth.user);


  return (
    <PageWithHeader>
      <Box sx={{ p: 3, maxWidth: 1400, margin: '0 auto' }}>
        {/* Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <IconButton onClick={() => router.push('/reviews')}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h4">360° Feedback Received</Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<EditIcon />}
            onClick={() => router.push('/reviews/360-degree-survey')}
          >
            Give Feedback
          </Button>
        </Box>

        <FeedbackSurveyResponses subjectUserId={currentUser?.id ?? ''} />
      </Box>
    </PageWithHeader>
  )
}

export default FeedbackSurveyReview;